<template>
  <MobileNav v-show="mounted" ref="$mobileMenu" @close="closeNav">
    <AsyncMobileNavContent v-if="headerData" />
  </MobileNav>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, ref, onMounted, defineAsyncComponent } from 'vue';
import { useEventBus, useEventListener, watchOnce } from '@vueuse/core';

import { GET_HEADER_DATA } from '#shared/types/getters';
import { OVERLAY, events } from '#shared/constants/eventBus';
import { useMobileNav } from '~/composables/useMobileNav';
import MobileNav from '~/components/header-mobile/MobileNav.common';
import MobileNavContent from '~/components/header-mobile/MobileNavContent.common.vue';

const navHeader = useNavHeader();
const { closeNav, isMenuOpened } = useMobileNav();

const AsyncMobileNavContent = defineAsyncComponent({
  loader: () => Promise.resolve(MobileNavContent),
  hydrate: (hydrate) => {
    watchOnce(isMenuOpened, (opened) => {
      if (opened) {
        hydrate();
      }
    });
  },
});

const mounted = ref(false);
const $mobileMenu = ref(null);
const headerData = computed(() => !!navHeader[GET_HEADER_DATA]);
const bus = useEventBus(OVERLAY);

onMounted(() => {
  mounted.value = true;
  bus.on((event) => {
    if (event === events[OVERLAY].CLICK && isMenuOpened.value) closeNav();
  });
  useEventListener(document, 'click', (e) => {
    if (
      isMenuOpened.value &&
      !$mobileMenu.value.$el.contains(e.target) &&
      !e.target.closest('[data-block-outside-click]') &&
      // check if target element still exists in DOM
      // as some elements with v-if may disappear before this event listener is called
      document.body.contains(e.target)
    ) {
      closeNav();
    }
  });
});
</script>
